import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { FavoritesPage } from './favorites';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from '../../components/components.module';
import { PipesModule } from '../../pipes/pipes.module';

@NgModule({
  declarations: [
    FavoritesPage
  ],
  imports: [
    IonicPageModule.forChild(FavoritesPage),
    TranslateModule.forChild(),
    ComponentsModule,
    PipesModule
  ],
  entryComponents: [
    FavoritesPage
  ]
})
export class FavoritesPageModule {}



// WEBPACK FOOTER //
// ./src/pages/favorites/favorites.module.ts